import { Typography as MuiTypography } from "@material-ui/core";
import { styled } from "@material-ui/styles";

export const Typography = styled(MuiTypography)(() => ({
  textDecoration: "none",
  "&:hover": {
    cursor: "pointer"
  }
}));
